module.exports = __webpack_public_path__ + "static/media/pearson-512.5d9d2460.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pearson-512.png
// module id = 778
// module chunks = 0